import { Box }                        from "@mui/material";
import { useGlobalConfig }            from "context/GlobalContext";
import { CreateOrEditRecoComponent }  from "./CreateOrEditRecoComponent";

export const RecoCreatePage = () => {
  const { rc } = useGlobalConfig();

  return (
    <Box sx={{ position: 'relative', textAlign: 'right', height: '100%', overflow: 'auto' }}>
      <CreateOrEditRecoComponent editMode="create"/>
    </Box>
  );
};
